import { fullUrl } from "@/components/app/ImageUploader";

export default function UserAvatar({ url, nickname, size = "h-9 w-9", className = "", testid }) {
  return (
    <div className={`${size} rounded-full overflow-hidden grid place-items-center shrink-0 font-bold text-sm ${url ? "bg-muted" : "bg-primary text-primary-foreground"} ${className}`} data-testid={testid}>
      {url ? <img src={fullUrl(url)} alt="" className="w-full h-full object-cover" /> : (nickname?.[0] || "?").toUpperCase()}
    </div>
  );
}

export function AvatarStack({ people, total, testid = "going-avatars" }) {
  if (!people?.length) return null;
  const shown = people.slice(0, 6);
  const extra = total - shown.length;
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <div className="flex -space-x-2">
        {shown.map((p) => <UserAvatar key={p.user_id} url={p.avatar_url} nickname={p.nickname} className="border-2 border-card" testid={`stack-avatar-${p.user_id}`} />)}
        {extra > 0 && <div className="h-9 w-9 rounded-full border-2 border-card bg-muted grid place-items-center text-xs font-bold" data-testid="avatar-stack-more">+{extra}</div>}
      </div>
    </div>
  );
}

export function PeopleList({ people, onReport, onRemove, testid = "people-list" }) {
  return (
    <ul className="space-y-2" data-testid={testid}>
      {people.map((p) => (
        <li key={p.user_id} className="flex items-center gap-3" data-testid={`person-${p.user_id}`}>
          <UserAvatar url={p.avatar_url} nickname={p.nickname} />
          <span className="flex-1 text-sm truncate">{p.nickname}</span>
          {onRemove && <button onClick={() => onRemove(p)} className="text-xs text-destructive press px-2 h-8" data-testid={`remove-person-${p.user_id}`}>Remover</button>}
          {onReport && p.avatar_url && <button onClick={() => onReport(p)} className="text-[11px] text-muted-foreground press px-2 h-8" data-testid={`report-avatar-${p.user_id}`}>Denunciar foto</button>}
        </li>
      ))}
    </ul>
  );
}
